var map = {
	"./clinic.svg": "30b9",
	"./darokhane_niavaran.svg": "0b0f",
	"./eram_kish.png": "37f4",
	"./flightio.png": "8948",
	"./homsa.png": "5f58",
	"./hotel_ghasr.svg": "6d69",
	"./media_left.svg": "cf99",
	"./media_right.svg": "50b2",
	"./samtik.png": "9fb3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "776b";